import { unref, type MaybeRef } from 'vue';

export type ScrollIntoViewTarget = MaybeRef<HTMLElement | null | undefined>;

export interface UseScrollIntoViewOptions extends ScrollIntoViewOptions {}

const defaultScrollIntoViewOptions: UseScrollIntoViewOptions = {
	behavior: 'smooth',
	block: 'start',
};

export const useScrollIntoView = (
	target: ScrollIntoViewTarget,
	defaultOptions: UseScrollIntoViewOptions = {}
) => {
	const scrollIntoView = (options: UseScrollIntoViewOptions = {}) => {
		const element = unref(target);
		if (!element || typeof element.scrollIntoView !== 'function') {
			return false;
		}

		element.scrollIntoView({
			...defaultScrollIntoViewOptions,
			...defaultOptions,
			...options,
		});

		return true;
	};

	return {
		scrollIntoView,
	};
};
